import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthStateService } from '../../shared/services/auth-state.service';
import { BrandService } from '../../shared/services/brand.service';

@Injectable()
export class BrandInterceptor implements HttpInterceptor {
  constructor(
    private brandService: BrandService,
    private authState: AuthStateService,
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const brandId = this.brandService.brandId ?? this.authState.brandId;
    if (!brandId) {
      return next.handle(req);
    }

    const headers: Record<string, string> = { 'X-Brand-Id': brandId };

    const categoryId = this.authState.activeCategoryId ?? this.authState.defaultCategoryId ?? this.brandService.categoryId;
    if (categoryId) {
      headers['X-Category-Id'] = categoryId;
    }

    return next.handle(req.clone({ setHeaders: headers }));
  }
}
